import React from "react";

const ResizeIcon = ({ viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-inherit" }) => {
  return (
    <svg data-testid="resize-icon" xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none" className={className}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M18.5 5.5l-5 5M10.5 13.5l-5 5M12.5 5.5h6v6M5.5 12.5v6h6"
      ></path>
    </svg>
  );
};

export default ResizeIcon;
